import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type AppStatusKind =
  'active' | 'inactive' | 'activatable' | 'not_in_plan' | 'coming_soon' | 'retired';

export const APP_STATUS_STYLES: Readonly<
  Record<AppStatusKind, { label: string; classes: string }>
> = {
  active: {
    label: 'Attiva',
    classes: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300',
  },
  inactive: {
    label: 'Disattivata',
    classes: 'bg-stone-100 text-stone-600 dark:bg-stone-800 dark:text-stone-300',
  },
  activatable: {
    label: 'Attivabile',
    classes: 'bg-bsite-100 text-bsite-700 dark:bg-bsite-950 dark:text-bsite-200',
  },
  not_in_plan: {
    label: 'Non inclusa nel piano',
    classes: 'bg-stone-100 text-stone-600 dark:bg-stone-800 dark:text-stone-300',
  },
  coming_soon: {
    label: 'In arrivo',
    classes: 'bg-stone-100 text-stone-600 dark:bg-stone-800 dark:text-stone-300',
  },
  retired: {
    label: 'Ritirata',
    classes: 'bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300',
  },
};

/** Stato di un'App nel catalogo del cantiere (spec 004 FR-003): pillola con pallino, come `bs-status-badge`. */
@Component({
  selector: 'bs-app-status',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex' },
  template: `
    <span [class]="classes()" [attr.data-app-status]="status()">
      <span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>
      {{ text() }}
    </span>
  `,
})
export class AppStatusComponent {
  readonly status = input.required<AppStatusKind>();
  /** Testo alternativo, per esempio "Ritirata dal 21/01/2027". */
  readonly label = input<string | null>(null);

  protected readonly text = computed(() => this.label() ?? APP_STATUS_STYLES[this.status()].label);
  protected readonly classes = computed(
    () =>
      `inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 text-xs font-semibold ring-1 ring-inset ring-current/20 ${APP_STATUS_STYLES[this.status()].classes}`,
  );
}
